'use strict';

module.exports = function simpleParse(url) {
  var parsed = {};

  var q = url.indexOf('?');
  var h = url.indexOf('#');
  var hasQuery = !!~q;
  var hasHash = !!~h;

  parsed.url = url.slice(0, hasQuery && q || hasHash && h || url.length);
  if (hasQuery) parsed.query = url.slice(q, hasHash && h || url.length);
  if (hasHash) parsed.hash = url.slice(h);

  return parsed;
};